import {
    LIST_OBJECTS,
    LIST_OBJECTS_SUCCESS,
    LIST_OBJECTS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
// import authToken from '../config/tokenUsers';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'objeto';

const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTY4MDUwMDYsInVzZXJfbmFtZSI6IjY3MjgiLCJhdXRob3JpdGllcyI6WyJFTElNSU5BUl9QQVJBTUVUUk9TIiwiTklWRUxFUyIsIlJFU0VSVkFSX0FVRElFTkNJQVMiLCJWRV9SRVBPUlRFUyIsIkNSRUFSX0lOSElCSUNJT05FUyIsIkVMSU1JTkFSX1RVUk5PUyIsIkxJU1RBUl9GVU5DSU9OQVJJT1MiLCJNT0RJRklDQVJfSlVFQ0VTIiwiQ1JFQVJfVVNVQVJJT1MiLCJNT0RJRklDQVJfVFVSTk9TIiwiRUxJTUlOQVJfSU5ISUJJQ0lPTkVTIiwiTU9ESUZJQ0FSX0ZVTkNJT05BUklPUyIsIkxJU1RBUl9PRklKVVMiLCJNT0RJRklDQVJfU09MSUNJVFVERVMiLCJWRVJfVklERU9TX0FVRElFTkNJQVMiLCJNT0RJRklDQVJfUEFSQU1FVFJPUyIsIk1PRElGSUNBUl9VU1VBUklPUyIsIkxJU1RBUl9KVUVDRVMiLCJFTElNSU5BUl9KVUVDRVMiLCJBR0VOREFSX0FVRElFTkNJQVMiLCJDQU5DRUxBUl9BVURJRU5DSUFTIiwiQ1JFQVJfUkVTVUxUQURPUyIsIkNSRUFSX1RVUk5PUyIsIk1PRElGSUNBUl9JTkhJQklDSU9ORVMiLCJMSVNUQVJfSU5ISUJJQ0lPTkVTIiwiRUxJTUlOQVJfVVNVQVJJT1MiLCJMSVNUQVJfVVNVQVJJT1MiLCJDUkVBUl9OT1RJRklDQUNJT05FUyIsIkNSRUFSX09GSUpVUyIsIlZFUl9BR0VOREEiLCJDUkVBUl9TT0xJQ0lUVURFUyIsIkVMSU1JTkFSX09GSUpVUyIsIkxJU1RBUl9QQVJBTUVUUk9TIiwiTU9ESUZJQ0FSX09GSUpVUyIsIlZFUl9BQ1RBU19BVURJRU5DSUFTIiwiRUxJTUlOQVJfRlVOQ0lPTkFSSU9TIiwiUkVWT0NBUl9TT0xJQ0lUVURFUyIsIkFDRVBUQVJfU09MSUNJVFVERVMiLCJMSVNUQVJfVFVSTk9TIiwiVkVSX0FDVEFTX0FVRElFTkNJQVNfUFJPUElBUyIsIkNSRUFSX0ZVTkNJT05BUklPUyIsIkNSRUFSX1BBUkFNRVRST1MiLCJWRVJfVklERU9TX0FVRElFTkNJQVNfUFJPUElBUyIsIkNSRUFSX0pVRUNFUyIsIlJFQ0hBWkFSX1NPTElDSVRVREVTIl0sImp0aSI6IjQwNTg4ODhiLTg2NzMtNDNkOS1iZTVlLWY2MWI4ODU0NGU2ZCIsImNsaWVudF9pZCI6ImZyb250ZW5kYXBwIiwic2NvcGUiOlsicmVhZCIsIndyaXRlIl19.WSvX8pYZLTdnS7RttDR47QqLvEkjMn2zuq52s8NGKQ4';

//LISTAR OBJECTS
export function listObjectsAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( listObjects() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            // authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`);
            //Obtengo los datos
            const objects = response.data;
            //Llamo al dispatch
            dispatch( listObjectsSuccess(objects.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listObjectsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listObjects = () => ({
    type: LIST_OBJECTS,
    payload: true
});

const listObjectsSuccess = objects => ({
    type: LIST_OBJECTS_SUCCESS,
    payload: objects
});

const listObjectsError = error => ({
    type: LIST_OBJECTS_ERROR,
    payload: error
});